import React from 'react';
import { Link } from 'react-router-dom';
import "bootstrap-icons/font/bootstrap-icons.css";

function Footer() {
    return (
        <footer className="py-12 bg-black border-t border-white/5 relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
                <div className="flex flex-col md:flex-row justify-between items-center gap-8">

                    <div className="flex items-center gap-4">
                        <div className="w-10 h-10 rounded-xl bg-green-500 text-black flex items-center justify-center font-black text-lg">
                            K
                        </div>
                        <div className="flex flex-col">
                            <p className="text-gray-400 font-bold uppercase tracking-widest text-xs">
                                &copy; {new Date().getFullYear()} Kwagala Moris Owen. <span className="text-gray-600 ml-2 hidden sm:inline">Built for Excellence.</span>
                            </p>
                            <Link to="/privacy-policy" className="text-gray-600 hover:text-green-500 transition-colors text-[10px] font-bold uppercase tracking-[0.2em] mt-1">
                                Privacy Policy
                            </Link>
                        </div>
                    </div>

                    <div className="flex items-center gap-8">
                        <a href="https://github.com/kwagalamoris" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors text-xl">
                            <i className="bi bi-github"></i>
                        </a>
                        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors text-xl">
                            <i className="bi bi-linkedin"></i>
                        </a>
                        <a href="mailto:kwagalamoris@gmail.com" className="text-gray-500 hover:text-white transition-colors text-xl">
                            <i className="bi bi-envelope-fill"></i>
                        </a>
                    </div>

                </div>
            </div>
        </footer>
    );
}

export default Footer;
